import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logoHero from "@/assets/logo-hero.webp";

interface SplashScreenProps {
  children: React.ReactNode;
}

const ease = [0.22, 1, 0.36, 1] as const;

const SplashScreen = ({ children }: SplashScreenProps) => {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <>
      <AnimatePresence>
        {showSplash && (
          <motion.div
            className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center gap-5"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.8, ease }}
            onAnimationComplete={(def: { opacity?: number }) => {
              if (def.opacity === 0) setShowSplash(false);
            }}
          >
            <motion.img
              src={logoHero}
              alt="Arzani"
              className="h-16 md:h-24 brightness-0"
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.8, ease }}
            />
            <motion.span
              className="font-display text-lg md:text-2xl tracking-[0.35em] uppercase text-foreground"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.4, delay: 0.8, ease }}
              onAnimationComplete={() => {
                setTimeout(() => setShowSplash(false), 1200);
              }}
            >
              Arzani Group
            </motion.span>
          </motion.div>
        )}
      </AnimatePresence>
      {children}
    </>
  );
};

export default SplashScreen;
